<section class="rs-content-wrapper rs-header-has-level2" id="tvLevelTwo">
  <ng-container *ngIf="selectedProduct; else skeleton">
    <main id="maincontent" role="main">
      <section class="rs-es-first-section">
        <mprd-back-link></mprd-back-link>
        <div class="row">
          <div class="columns small-12">
            <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
              {{ selectedProduct?.productDescription }}
            </h1>
            <p class="rs-txt-s5 rs-txt-c2 small-only-text-center" x-ms-format-detection="none">
              {{ selectedProduct?.accessNumber }}
            </p>
            <div class="panel rs-panel-big clearfix">
              <mprd-usage-header
                [product]="selectedProduct"
                [remainingDaysLabel]="remainingDaysLabel"
                *ngIf="remainingDaysLabel"
              ></mprd-usage-header>
              <div class="row" data-masonry-container="">
                <div class="columns small-12" data-masonry-item-sizer=""></div>
                <div class="columns small-12" data-masonry-item="">
                  <px-usage-level-2-container
                    [product]="usageProduct"
                    (usageRemainingDays)="usageInitializedWith($event)"
                  ></px-usage-level-2-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </ng-container>
  <ng-template #skeleton>
    <section class="rs-es-first-section">
      <div class="row">
        <div class="columns small-12">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
          <div class="small-only-text-center">
            <div>
              <div
                class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
          <div class="panel rs-panel-big clearfix">
            <div class="row" data-masonry-container="">
              <div class="columns small-12" data-masonry-item-sizer=""></div>
              <div class="columns small-12" data-masonry-item="">
                <px-usage-level-2-container></px-usage-level-2-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-template>
</section>
